import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useMount from '../../../../../common/hooks/useMount';
import Breadcrumbs from '../../../../../common/widgets/Breadcrumbs';
import Loader from '../../../../../common/widgets/Loader';
import LoadingSpinner from '../../../../../common/widgets/LoadingSpinner';
import { parseProducts } from '../../../helpers';
import { ProductListModel } from '../../../models/Product';
import { resources } from '../../../resources/resources';
import { wishlistService } from '../../../services/wishlist';
import applicationCrumbs from '../../ApplicationCrumbs';
import { EmptyStateFavorites } from '../../Common/EmptyStates';
import PlatformInformation from '../../Common/PlatformInformation';
import ProductListItem from '../../Common/ProductListItem';
import MyAccountMenu from '../Common/MyAccountMenu';

export const WishlistPage = () => {
  const { t: translate } = useTranslation();
  const crumbs = applicationCrumbs(translate);
  const [products, setProducts] = useState<ProductListModel[] | null>(null);
  const [showErrorPanel, setShowErrorPanel] = useState<boolean>(false);

  const loadProducts = async (abortController?: AbortController) => {
    const result = await wishlistService.getProducts({
      signal: abortController?.signal,
    });
    if (!result.hasErrors) {
      setProducts(result.data);
    } else {
      if (!abortController?.signal.aborted) {
        setShowErrorPanel(true);
      }
    }
  };

  useMount(loadProducts);

  return (
    <>
      <Breadcrumbs
        entries={[crumbs.home, crumbs.accountDashboard, crumbs.wishlist]}
      />
      <section className="section-main section-actions my-account-page">
        <div className="container">
          <div className="area-actions">
            <MyAccountMenu />
          </div>
          <div className="area-content">
            <PlatformInformation />
            <h1>{translate(resources.menu.wishlist)}</h1>
            <section className="page-section mb-30">
              <Loader
                loading={!products}
                loader={<LoadingSpinner />}
                showErrorPanel={showErrorPanel}
              >
                {products?.length ? (
                  <div className="card-list card-list-4 card-list-sm-3 card-list-xs-2">
                    {parseProducts(products)?.map(p => (
                      <ProductListItem key={p.productId} product={p} />
                    ))}
                  </div>
                ) : (
                  <EmptyStateFavorites />
                )}
              </Loader>
            </section>
          </div>
        </div>
      </section>
    </>
  );
};
